import { useEffect, useState } from 'react';

function createFisicaDraft(pessoaId = null) {
    return {
        pessoaId: pessoaId || null,
        dataNascimento: '',
        sexo: 'Desconhecido',
        tipoSanguineo: 'Desconhecido',
        estadoCivil: 'Desconhecido',
        nacionalidadeId: 1,
        profissaoId: null,
        profissaoDescricao: '',

        pai: '',
        mae: '',

        cnh: '',
        cnhCategoriaId: '',
        cnhPrimeira: '',
        cnhValidade: '',
        cnhExameToxicologicoValidade: '',
        pis: '',
        titulo: '',
        zona: '',
        secao: '',
        ctps: '',
        medico: false,
        crm: '',
        creci: '',
    };
}

export function usePessoaFisicaModule({ pessoaId, pessoaFisica, setPessoaFisica }) {
    const [dados, setDados] = useState(createFisicaDraft(pessoaId));

    useEffect(() => {
        if (pessoaFisica && Object.keys(pessoaFisica).length > 0) {
            setDados({
                pessoaId: pessoaFisica.pessoaId || pessoaId,
                dataNascimento: pessoaFisica.dataNascimento || '',
                sexo: pessoaFisica.sexo || 'Desconhecido',
                tipoSanguineo: pessoaFisica.tipoSanguineo || 'Desconhecido',
                estadoCivil: pessoaFisica.estadoCivil || 'Desconhecido',
                nacionalidadeId: pessoaFisica.nacionalidadeId || 1,
                profissaoId: pessoaFisica.profissaoId || null,
                profissaoDescricao: pessoaFisica.profissaoDescricao ?? pessoaFisica.Profissao?.descricao ?? '',
                pai: pessoaFisica.pai || '',
                mae: pessoaFisica.mae || '',

                cnh: pessoaFisica.cnh || '',
                cnhCategoriaId: pessoaFisica.cnhCategoriaId || '',
                cnhPrimeira: pessoaFisica.cnhPrimeira || '',
                cnhValidade: pessoaFisica.cnhValidade || '',
                cnhExameToxicologicoValidade: pessoaFisica.cnhExameToxicologicoValidade || '',
                pis: pessoaFisica.pis || '',
                titulo: pessoaFisica.titulo || '',
                zona: pessoaFisica.zona || '',
                secao: pessoaFisica.secao || '',
                ctps: pessoaFisica.ctps || '',
                medico: !!pessoaFisica.medico,
                crm: pessoaFisica.crm || '',
                creci: pessoaFisica.creci || '',
            });
        } else {
            setDados(createFisicaDraft(pessoaId));
        }
    }, [pessoaFisica, pessoaId]);

    function change(e) {
        const { name, value, type, checked } = e.target;
        const field = name.split('.')[1];

        const nextValue = type === 'checkbox' ? checked : value;

        setDados((prev) => {
            const next = {
                ...prev,
                [field]: nextValue,
            };

            if (typeof setPessoaFisica === 'function') {
                setPessoaFisica(next);
            }

            return next;
        });
    }

    function selecionarProfissao(id, descricao) {
        const next = { ...dados, profissaoId: id || '', profissaoDescricao: descricao || '' };
        setDados(next);
        if (typeof setPessoaFisica === 'function') setPessoaFisica(next);
    }

    return {
        state: {
            dados,
        },
        actions: {
            change,
            selecionarProfissao,
            setDados,
        },
    };
}
